// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme System Styles */

/* Theme transition animations */
* {
  transition: background-color var(--transition-base), 
              color var(--transition-base), 
              border-color var(--transition-base);
}

/* Theme-specific component styles */

/* Cards in different themes */
.card {
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--spacing-6);
  box-shadow: var(--shadow-sm);
  transition: all var(--transition-base);
}

.card:hover {
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

/* Navigation in different themes */
.navigation {
  background-color: var(--color-surface-elevated);
  border-bottom: 1px solid var(--color-border);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* Hero section theme adaptations */
.hero {
  background: linear-gradient(135deg, 
    var(--color-primary) 0%, 
    var(--color-primary-light) 100%);
  color: white;
}

/* Form elements in different themes */
.form-group {
  margin-bottom: var(--spacing-4);
}

.form-label {
  display: block;
  margin-bottom: var(--spacing-2);
  font-weight: var(--font-weight-medium);
  color: var(--color-text);
}

.form-input {
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  font-size: var(--font-size-base);
  transition: all var(--transition-fast);
}

.form-input:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}

.form-input.error {
  border-color: var(--color-error);
}

.form-input.error:focus {
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);
}

/* Error and success messages */
.form-error {
  color: var(--color-error);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.form-success {
  color: var(--color-success);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-1);
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

/* Loading states for different themes */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--color-primary-rgb), 0.1);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--z-modal);
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Toast notifications for different themes */
.toast {
  position: fixed;
  top: var(--spacing-4);
  right: var(--spacing-4);
  background-color: var(--color-surface-elevated);
  color: var(--color-text);
  padding: var(--spacing-4) var(--spacing-6);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  border: 1px solid var(--color-border);
  z-index: var(--z-toast);
  animation: slideInRight 0.3s ease-out;
}

.toast.success {
  border-left: 4px solid var(--color-success);
}

.toast.error {
  border-left: 4px solid var(--color-error);
}

.toast.warning {
  border-left: 4px solid var(--color-warning);
}

.toast.info {
  border-left: 4px solid var(--color-info);
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Modal styles for different themes */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: var(--z-modal-backdrop);
  animation: fadeIn 0.2s ease-out;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--color-surface-elevated);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-2xl);
  z-index: var(--z-modal);
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  animation: scaleIn 0.2s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* Dropdown styles for different themes */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background-color: var(--color-surface-elevated);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: var(--z-dropdown);
  min-width: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all var(--transition-fast);
}

.dropdown.open .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  color: var(--color-text);
  text-decoration: none;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.dropdown-item:hover {
  background-color: var(--color-surface);
}

.dropdown-item:first-child {
  border-top-left-radius: var(--radius-lg);
  border-top-right-radius: var(--radius-lg);
}

.dropdown-item:last-child {
  border-bottom-left-radius: var(--radius-lg);
  border-bottom-right-radius: var(--radius-lg);
}

/* Print styles */
@media print {
  * {
    background: white !important;
    color: black !important;
    box-shadow: none !important;
  }
  
  .navigation,
  .modal,
  .toast {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/themes.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB,gCAAgC;AAChC;EACE;;iDAE+C;AACjD;;AAEA,oCAAoC;;AAEpC,8BAA8B;AAC9B;EACE,sCAAsC;EACtC,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,mCAAmC;AACnC;EACE,+CAA+C;EAC/C,4CAA4C;EAC5C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,mCAAmC;AACnC;EACE;;oCAEkC;EAClC,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qDAAqD;EACrD,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,wBAAwB;EACxB,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+CAA+C;EAC/C,+BAA+B;EAC/B,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,2CAA2C;EAC7C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,+CAA+C;EAC/C,qCAAqC;EACrC,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,wBAAwB;EACxB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;;IAGE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Theme System Styles */\r\n\r\n/* Theme transition animations */\r\n* {\r\n  transition: background-color var(--transition-base), \r\n              color var(--transition-base), \r\n              border-color var(--transition-base);\r\n}\r\n\r\n/* Theme-specific component styles */\r\n\r\n/* Cards in different themes */\r\n.card {\r\n  background-color: var(--color-surface);\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-lg);\r\n  padding: var(--spacing-6);\r\n  box-shadow: var(--shadow-sm);\r\n  transition: all var(--transition-base);\r\n}\r\n\r\n.card:hover {\r\n  box-shadow: var(--shadow-md);\r\n  transform: translateY(-2px);\r\n}\r\n\r\n/* Navigation in different themes */\r\n.navigation {\r\n  background-color: var(--color-surface-elevated);\r\n  border-bottom: 1px solid var(--color-border);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n}\r\n\r\n/* Hero section theme adaptations */\r\n.hero {\r\n  background: linear-gradient(135deg, \r\n    var(--color-primary) 0%, \r\n    var(--color-primary-light) 100%);\r\n  color: white;\r\n}\r\n\r\n/* Form elements in different themes */\r\n.form-group {\r\n  margin-bottom: var(--spacing-4);\r\n}\r\n\r\n.form-label {\r\n  display: block;\r\n  margin-bottom: var(--spacing-2);\r\n  font-weight: var(--font-weight-medium);\r\n  color: var(--color-text);\r\n}\r\n\r\n.form-input {\r\n  width: 100%;\r\n  padding: var(--spacing-3) var(--spacing-4);\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-md);\r\n  background-color: var(--color-surface);\r\n  color: var(--color-text);\r\n  font-size: var(--font-size-base);\r\n  transition: all var(--transition-fast);\r\n}\r\n\r\n.form-input:focus {\r\n  outline: none;\r\n  border-color: var(--color-primary);\r\n  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);\r\n}\r\n\r\n.form-input.error {\r\n  border-color: var(--color-error);\r\n}\r\n\r\n.form-input.error:focus {\r\n  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);\r\n}\r\n\r\n/* Error and success messages */\r\n.form-error {\r\n  color: var(--color-error);\r\n  font-size: var(--font-size-sm);\r\n  margin-top: var(--spacing-1);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-1);\r\n}\r\n\r\n.form-success {\r\n  color: var(--color-success);\r\n  font-size: var(--font-size-sm);\r\n  margin-top: var(--spacing-1);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--spacing-1);\r\n}\r\n\r\n/* Loading states for different themes */\r\n.loading-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(var(--color-primary-rgb), 0.1);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: var(--z-modal);\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid var(--color-border);\r\n  border-top: 4px solid var(--color-primary);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n/* Toast notifications for different themes */\r\n.toast {\r\n  position: fixed;\r\n  top: var(--spacing-4);\r\n  right: var(--spacing-4);\r\n  background-color: var(--color-surface-elevated);\r\n  color: var(--color-text);\r\n  padding: var(--spacing-4) var(--spacing-6);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-lg);\r\n  border: 1px solid var(--color-border);\r\n  z-index: var(--z-toast);\r\n  animation: slideInRight 0.3s ease-out;\r\n}\r\n\r\n.toast.success {\r\n  border-left: 4px solid var(--color-success);\r\n}\r\n\r\n.toast.error {\r\n  border-left: 4px solid var(--color-error);\r\n}\r\n\r\n.toast.warning {\r\n  border-left: 4px solid var(--color-warning);\r\n}\r\n\r\n.toast.info {\r\n  border-left: 4px solid var(--color-info);\r\n}\r\n\r\n@keyframes slideInRight {\r\n  from {\r\n    transform: translateX(100%);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Modal styles for different themes */\r\n.modal-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: var(--z-modal-backdrop);\r\n  animation: fadeIn 0.2s ease-out;\r\n}\r\n\r\n.modal {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background-color: var(--color-surface-elevated);\r\n  border-radius: var(--radius-xl);\r\n  box-shadow: var(--shadow-2xl);\r\n  z-index: var(--z-modal);\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  overflow: auto;\r\n  animation: scaleIn 0.2s ease-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes scaleIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translate(-50%, -50%) scale(0.9);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translate(-50%, -50%) scale(1);\r\n  }\r\n}\r\n\r\n/* Dropdown styles for different themes */\r\n.dropdown {\r\n  position: relative;\r\n  display: inline-block;\r\n}\r\n\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  background-color: var(--color-surface-elevated);\r\n  border: 1px solid var(--color-border);\r\n  border-radius: var(--radius-lg);\r\n  box-shadow: var(--shadow-lg);\r\n  z-index: var(--z-dropdown);\r\n  min-width: 200px;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  transform: translateY(-10px);\r\n  transition: all var(--transition-fast);\r\n}\r\n\r\n.dropdown.open .dropdown-menu {\r\n  opacity: 1;\r\n  visibility: visible;\r\n  transform: translateY(0);\r\n}\r\n\r\n.dropdown-item {\r\n  display: block;\r\n  width: 100%;\r\n  padding: var(--spacing-3) var(--spacing-4);\r\n  color: var(--color-text);\r\n  text-decoration: none;\r\n  border: none;\r\n  background: none;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color var(--transition-fast);\r\n}\r\n\r\n.dropdown-item:hover {\r\n  background-color: var(--color-surface);\r\n}\r\n\r\n.dropdown-item:first-child {\r\n  border-top-left-radius: var(--radius-lg);\r\n  border-top-right-radius: var(--radius-lg);\r\n}\r\n\r\n.dropdown-item:last-child {\r\n  border-bottom-left-radius: var(--radius-lg);\r\n  border-bottom-right-radius: var(--radius-lg);\r\n}\r\n\r\n/* Print styles */\r\n@media print {\r\n  * {\r\n    background: white !important;\r\n    color: black !important;\r\n    box-shadow: none !important;\r\n  }\r\n  \r\n  .navigation,\r\n  .modal,\r\n  .toast {\r\n    display: none !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
